import { Component, OnInit } from '@angular/core';
import { environment } from 'src/environments/environment';
import { ThemeService } from './shared/services/theme.service';
import { AppState } from './shared/stores/states/app.state';
import { Store } from '@ngrx/store';

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrl: './app.component.scss',
})
export class AppComponent implements OnInit {
  title = 'EMiRLD';
  constructor(private themeService: ThemeService, private store: Store<AppState>) { }

  ngOnInit(): void {
    this.store.dispatch({ type: '[App] Init' });
    let themeName =
      this.themeService.getCurrentThemeName() || environment.defaultTheme;
    this.themeService.applyThemeByName(themeName);
  }
}
